import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center"} }, "Face Mapping"),
  /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center","margin":"5px 0 0 10px","font-size":"8px"} })
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Load Face ")
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_MediaCard = _resolveComponent("MediaCard")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"flex":"1"} }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_a_button, {
          disabled: _ctx.disabled,
          onClick: _ctx.loadFace
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facesArray, (face, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: face.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: face.mediaUrl,
              style: {"width":"30%","height":"30%","max-width":"100px","max-height":"100px","object-fit":"contain","border-radius":"10px"}
            }, null, 8, _hoisted_5),
            _createVNode(_component_RightOutlined, { style: {"margin":"0 20px","font-size":"12px"} }),
            _createVNode(_component_MediaCard, {
              search: "",
              onChange: (e) => _ctx.onChangeTargetImage(e, index)
            }, null, 8, ["onChange"])
          ]),
          (_ctx.facesArray.length !== index + 1)
            ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}